import { render, staticRenderFns } from "./AdverseEventDataTable.vue?vue&type=template&id=350d9adb"
import script from "./AdverseEventDataTable.vue?vue&type=script&lang=js"
export * from "./AdverseEventDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports